import { getToken } from "../../../API/VolumesAPI";

// Read-only calls for the DATA screen (backend reference_data.py).
const get = async (what) => {
  const response = await fetch("/api/reference/" + what, { headers: { Authorization: "Bearer " + getToken() } });
  if (!response.ok) throw new Error(`Kon nie ${what} laai nie (${response.status})`);
  return response.json();
};

const ReferenceDataAPI = {
  getPricing: () => get("pricing"),
  getBundles: () => get("bundles"),
  getChoices: () => get("choices"),
  getProducts: () => get("products"),
};

export default ReferenceDataAPI;
